export default {
  en: {
    'pages-filing-summary-page-components.filing-tabs.tab.ecsl': 'ECSL',
    'pages-filing-summary-page-components.filing-tabs.tab.ecpl': 'ECPL',
    'pages-filing-summary-page-components.filing-tabs.tab.prepare': 'Prepare',
    'pages-filing-summary-page-components.filing-tabs.tab.draft-return': 'Draft Return',
    'pages-filing-summary-page-components.filing-tabs.tab.filed-return': 'Filed Return',
    'pages-filing-summary-page-components.filing-tabs.tab.payment': 'Payment',
  },
};
